export default {

  init() {

    $('.header__destinations__toggle').click(function() {
      $(this).closest('.header__destinations').toggleClass('--open')
    })

    $(window).click(function() {
      $('.header__destinations').removeClass('--open')
    });

    $('.header__destinations__toggle, .destinations-menu__link').click(function(event){
      event.stopPropagation();
    });

    $('.main-menu > li').each(function() {
      if ($(this).find('> ul').length) {
        var level_name = $(this).find('> a').text();
        $(this).find('> ul').prepend('<li class="level-title"><button class="back-level-js"><i class="icon-arrow-right-3"></i></button>' + level_name +'</li>')
      }
    })

    $('.back-level-js').click(function(event){
      $('.header__main-menu-wrapper').removeClass('--second-level');
    });

    let reset_menu_timer = null

    $('.main-menu > li > a').click(function(event){
      if ($.mlmi.mobile.isMobile) {
        $('.main-menu li, .header__main-menu__highlights').removeClass('--open-sub-menu')
        $(this).closest('li').addClass('--open-sub-menu')
        $('.header__main-menu-wrapper').addClass('--second-level');
        $('.header__main-menu-wrapper').scrollTop(0)
        $('.header__main-menu__highlights .grid').scrollTop(0);
        $('.header__main-menu-wrapper .main-menu__sub-menu').scrollTop(0);
        return false;
      }
    });

    $('.js-open-highlights').click(function(event){
      if ($.mlmi.mobile.isMobile) {
        $('.header__main-menu__highlights').addClass('--open-sub-menu')
        return false;
      }
    });

    $('.main-menu > li > a').on("click", function() {
      if (!$.mlmi.mobile.isMobile) {
        return false;
      }
    });

    $('.main-menu > li > a').on( "mouseenter", function() {
      if (!$.mlmi.mobile.isMobile) {
        $('.main-menu li').removeClass('--open-sub-menu')
        $(this).closest('li').addClass('--open-sub-menu')
      }
    });

    $('.main-menu a[data-id]').on("mouseenter", function() {
      if (!$.mlmi.mobile.isMobile) {
        var item_image = window.menu_images_desktop[$(this).attr('data-id')];
        var item_title = $(this).attr('data-title')
        var item_location = $(this).attr('data-location')
        if (item_image) {
          var new_stage = $('<div class="header__main-menu__stage__item header-stage-item --new"></div>');
          new_stage.append('<div class="header-stage-item__image">' + item_image + '</div>');
          if (item_title) {
            new_stage.append('<div class="header-stage-item__title">' + item_title + '</div>');
          }
          if (item_location) {
            new_stage.append('<div class="header-stage-item__location">' + item_location + '</div>');
          }
          new_stage.find('img').load(function() {
            $(this).closest('.header-stage-item').addClass('--show');
          })
          var oldStages = $('.header-stage-item:not(.--default)')
          $('.header__main-menu__stage').prepend(new_stage);
          setTimeout(function() {
            oldStages.remove()
          }, 1000)
        }
      }
    });

    $('.main-menu').on("mouseleave", function() {
      clearTimeout(reset_menu_timer);
      reset_menu_timer = setTimeout(function() {
        if (!$.mlmi.mobile.isMobile) {
          $('.main-menu li').removeClass('--open-sub-menu')
          $('.header-stage-item:not(.--default):not(:nth-child(1))').remove();
          $('.header-stage-item').removeClass('--show');
        }
      }, 1500);
    });

    $('.main-menu').on("mouseenter", function() {
      clearTimeout(reset_menu_timer);
    });

    /* Menu Image management */
    let mobile_ready = false;
    function initMobile() {
      if (!mobile_ready) {
        $('.main-menu ul a[data-id]').each(function() {
          var menu_item_id = $(this).attr('data-id');
          if (window.menu_images_mobile[menu_item_id]) {
            $(this).html('<span>' + $(this).html() + '</span>');
            $(this).prepend('<div>' + window.menu_images_mobile[menu_item_id] + '</div>');
          }
        })
        mobile_ready = true;
      }
    }

    $.mlmi.mobile.mobileCallbacks.push(function() {
      initMobile();
    })

    if ($.mlmi.mobile.isMobile) {
      initMobile();
    }

    /* Back to top */
    $('.js-back-to-top').click(function() {
      $('body, html').scrollTo(0, 400, 5, 'easeInOutQuart')
    })

    /* Share */
    $('.js-share').on('click', function() {
      if ($('.post-share').attr('aria-expanded') == "true") {
        $('.post-share').attr('aria-expanded', false);
      } else {
        $('.post-share').attr('aria-expanded', true);
      }
    })

    $('.post-share__action--copy-link').on('click', function() {
      let self = $(this)
      self.original_text = self.find('.label').html()
      self.find('.label').css('width', self.find('.label').width() + 'px')
      self.find('textarea').val(window.location.href).focus().select()
      document.execCommand("Copy")
      self.find('.label').html(self.find('.copied').html());
      setTimeout(function() {
        self.find('.label').html(self.original_text);
      }, 3200)
    })

    $(window).click(function() {
      $('.post-share').attr('aria-expanded', 'false');
    });

    $('.post-share, .js-share').click(function(event){
      event.stopPropagation();
    });
  }
}
